import {combineReducers} from 'redux'

export default combineReducers({
  session: require('./AuthRedux').reducer,
  notifications: require('./NotificationRedux').reducer,
})
